import React from 'react';
import globalStyles from '../../styles';
import Panel from './Panel';
import SalesmanList from '../../components/Panel/Salesmans/SalesmanList';
import {Link} from 'react-router';
import urlBase from '../../url-base';


  const styles = {
    tituloPagina: {
      fontSize: 20,
      fontWeight: 'bold'
    },
    breadcrumb: {
      fontSize: 12,
      float: 'right'
    }
  };

const SalesmansPage = () => {

  return (
    <Panel>
      <div>
        <div style={styles.breadcrumb}>
          <i className="fa fa-home">&nbsp;</i>
          <Link to={urlBase.client + 'panel'}>Home</Link>
          &nbsp;>&nbsp;
          <Link style={{color:'#505050'}} to={urlBase.client + "panel/salesmans"}>
            Vendedores
          </Link>
        </div>

        <h3 style={globalStyles.navigation}>
          Lista de
          <span style={styles.tituloPagina}> Vendedores</span>
        </h3>

        <SalesmanList />

      </div>
    </Panel>

  );
};

export default SalesmansPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/SalesmansPage.js
 **/